<app-top-navigation [hasStatusMenu]="true" (eventChangeStatusEmitter)="clearSelectedAllItems()" [active]="active" [hideButtons]="emptyList || errorOnLoading" [hasBackLink]="false">
  <span title>Listagem de Colaboradores</span>
  <div links>
    <a *ngIf="!errorOnLoading" routerLink="/new" (click)="trackEventsSegment('click_button_import')" type="button" class="btn-import-collaborators import">Importar colaboradores</a>
  </div>
</app-top-navigation>
<ng-container *ngIf="!emptyList && !errorOnLoading">
  <div class="search-container">
    <up-search-collaborator (emitQuerySearch)="searchCollaborator($event)"></up-search-collaborator>
  </div>

  <up-feature-list-filters
    (params)="filterParams($event)"
    [departments]="departments$"
    [units]="units$"
    [roles]="roles$"
    [isCollaboratorModule]="true"
    [theme]="'unico-rebrand'"
    >
  </up-feature-list-filters>
  <div class="counter-container">
    <div class="counter-container__content">
      <div class="counter-container__batch-actions">
        <ng-container *ngIf="listItemsSelected.length">
          <p class="counter-container__batch-actions__counter">{{listItemsSelected.length}} {{listItemsSelected.length > 1 ? 'Selecionados' : 'Selecionado'}} </p>
          <button class="counter-container__batch-actions__button" attr.data.test="btnChangeStatusListing" (click)="openDialogChangeStatus()">
            {{active === 'active' ? 'Inativar' : 'Ativar'}}
          </button>
          <button *ngIf="hasFilter" class="counter-container__batch-actions__button" (click)="selectItemsInAllPages()">Selecionar todos os resultados</button>
          <div class="button-icon-container" *ngIf="isUserEligibleForUnicoSkillTrial">
            <img class="icon" src="/assets/images/book.svg" alt="ícone de livro" />
            <button class="counter-container__batch-actions__button" (click)="activeTrialSelectedUsers()">Ativar licença Unico Skill ({{ this.unicoSkillTrial.license_used }} de 100)</button>
          </div>
          <button class="counter-container__batch-actions__button" (click)="clearSelectedAllItems()">Limpar seleção</button>
        </ng-container>
      </div>
      <p class="counter-container__text">{{page}} - {{limit}} de {{total}}</p>
    </div>
  </div>
</ng-container>
<section *ngIf="collaborators$ | async as collaborators; else loadingOrError">
  <ng-container *ngIf="collaborators.length; else noItems;">
    <div class="list-filters-container">
      <ul class="list-dashboard-filters" [ngClass]="{'inactive-list': this.active === 'inactive'}" >
        <li class="item-filter-dashboard"><input #typeSelect class="gnm-c-checkbox" [checked]="listItemsSelected.length" (click)="selectAllItems($event)" type="checkbox" name="select-all" id="select-all"></li>
        <li class="item-filter-dashboard" (click)="orderByName()"><p class="sort" [ngClass]="{'--ascending': isAscendingOrder, '--descending' : !isAscendingOrder }">Nome</p></li>
        <li class="item-filter-dashboard">Matrícula</li>
        <li class="item-filter-dashboard">Cargo</li>
        <li class="item-filter-dashboard">Departamento</li>
        <li class="item-filter-dashboard">Filial</li>
        <li *ngIf="this.active === 'inactive'" class="item-filter-dashboard">Data desligamento</li>
      </ul>
    </div>
    <section class="home-dashboard-list">
      <div>
        <app-item-collaborator
          *ngFor="let collaborator of collaborators | paginate: { id: 'server', itemsPerPage: limit, currentPage: page, totalItems: total }; trackBy: trackByItems"
          [item]="collaborator"
          [departments]="departments$ | async"
          [units]="units$ | async"
          [roles]="roles$ | async"
          [isInactiveList]="active === 'inactive' ? true : false"
          [selected]="allItemsSelected || listItemsSelected.includes(collaborator.id)"
          (selectEvent)="toggleCurrentItem($event, collaborator.id)"
          >
        </app-item-collaborator>
        <up-feature-pagination [newBrand]="true" [limit]="limit" [total]="total" (pageChange)="getPage($event)" (limitChange)="getPageForLimit($event)"></up-feature-pagination>
      </div>
    </section>
  </ng-container>
  <ng-template #noItems>
    <div *ngIf="hasFilter || searchQuery || !collaborators.length;" class="list-dashboard-people">
      <div class="no-user">
        <img src="/assets/images/ico-anonymous.svg" alt="Nenhum colaborador encontrado." class="animated fadeInDown">
        <div class="animated fadeInUp">
          <h2 *ngIf="hasFilter || !collaborators.length && !searchQuery else notFoundSearch">Nenhum colaborador foi encontrado nesse filtro.</h2>
          <ng-template #notFoundSearch>
            <h2 >Nenhum colaborador encontrado com a busca "{{searchQuery}}"</h2>
          </ng-template>
          <p *ngIf="hasFilter">Tente novamente usando outros parâmetros.</p>
        </div>
      </div>
    </div>
  </ng-template>
</section>

<ng-template #loadingOrError>
  <div *ngIf="error$ | async as error; else loading" class="home-loading error-loading">
    <up-feature-status-error [code]="error?.status"></up-feature-status-error>
  </div>
  <ng-template #loading>
    <div *ngIf="!hasFilter && !searchQuery && !emptyList" class="home-loading">
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
    <div *ngIf="!hasFilter && !searchQuery && emptyList" class="list-empty animated fadeInDown">
      <div class="list-empty__image">
        <img src="/assets/images/ico-idea.svg" alt="Nenhum colaborador importado">
      </div>
      <div class="list-empty__infos" data-test="listEmpty">
        <h3 data-test="titleListEmpty">Você ainda não importou nenhum colaborador.</h3>
        <p>As informações dos colaboradores serão exibidas aqui.</p>
        <a routerLink="/new" type="button" data-test="btnImportListEmpty" (click)="trackEventsSegment('button_empty_page')" class="btn-import-collaborators import">Importar colaboradores</a>
      </div>
    </div>
  </ng-template>
</ng-template>
